/**
 * The SAS kind choice with every unavailable kind's reason visible under it (UI/UX fix round A, review U19), not only in
 * a hover title.
 */
import type { StorageSasKind } from '../../../../../../types/azureStorage';
import { RadioGroup, RadioGroupItem } from '../../../../../../components/ui/radio-group';

const KINDS: ReadonlyArray<[StorageSasKind, string]> = [['account', 'Account'], ['service', 'Service'], ['user-delegation', 'User delegation']];

export function SasKindFields({ value, reasonOf, onChange }: { value: StorageSasKind; reasonOf: (kind: StorageSasKind) => string | undefined; onChange: (kind: StorageSasKind) => void }) {
  const unavailable = KINDS.flatMap(([kind, label]) => { const reason = reasonOf(kind); return reason ? [{ label, reason }] : []; });
  return (
    <fieldset>
      <legend className="text-sm font-medium">Kind</legend>
      {/* U40 (A+B merge): the shared RadioGroup, not native radios. */}
      <RadioGroup value={value} onValueChange={(kind) => onChange(kind as StorageSasKind)} aria-label="Kind" className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
        {KINDS.map(([kind, label]) => (
          <label key={kind} className="flex items-center gap-1.5 text-sm" title={reasonOf(kind)}>
            <RadioGroupItem value={kind} aria-label={label} title={reasonOf(kind)} disabled={!!reasonOf(kind)} /> {label}
          </label>
        ))}
      </RadioGroup>
      {unavailable.length > 0 && (
        <ul className="mt-1 space-y-0.5 text-xs text-muted-foreground" data-testid="storage-sas-kind-reasons">
          {unavailable.map(({ label, reason }) => <li key={label}><span className="font-medium">{label}</span> is not available: {reason}</li>)}
        </ul>
      )}
    </fieldset>
  );
}
